import React from "react";
import Image from '../components/image.png' 
import './styles.css'
import { Link } from "react-router-dom";
import Mypic from '../images/mypic.png'
import Api from '../images/api.png';
import Bootstrap from '../images/bootstrap.png';
import Cpp from '../images/cpp.png'
import Java from '../images/java.png'
import Reactjs from '../images/react.png'
import Redux from '../images/redux.png'
import Css from '../images/css.png'
import Html from '../images/html.png'
import Javascript from '../images/javascript.png'
import Mui from '../images/mui.png'
import Nodejs from '../images/nodejs.png'
import Insta from '../images/insta.png'
import Linkdin from '../images/linkdin.png'
import Github from '../images/github.png'
import Mail from '../images/mail.png'
import Twitter from '../images/twitter.png'
import Resume from './Aishwary_Patle.pdf'



const HomePage = () =>
{
    const logos = [Api,Reactjs,Redux,Javascript,Css,Html,Bootstrap,Mui,Nodejs,Java,Cpp] 

    return(
        <>
            <div className="d-grid justify-content-center align-items-center">
                
                <section className="m-2 vw-50">
                    <img className='Image mt-5' src={Image} alt="This is pic"></img>
                    <div className="d-grid justify-content-center align-items-center" >
                    <h5 className="d-block m-auto fw-bolder mt-4 p-1">Hi 🙋‍♂️, I am Aishwary, a Frontend Developer 👨‍💻</h5>
                    <p className="d-block m-auto mt-3 p-1">I am Pursuing Bachelor of Engineering From Nagpur</p>
                    <p className="d-block m-auto mt-2 p-1">I am Passionate for coding and aspiring Full stack Developer who loves to code!</p>
                    
                    </div>
                    <a className="button p-2 m-auto mt-5"href={Resume} download>
                        Resume
                    </a>
                        
                    
                </section>

                <section className="Dark mt-5">
                        <h2 className="m-auto fw-bolder mt-5">Projects</h2>
                        <p className="mt-4 p-3">I will show you my some works so You can see my coding skills</p>
                        <Link className="button p-2 mt-3" to='/projects'>See Projects</Link>
                </section>

                <section className="White">
                    <h2 className="m-auto fw-bolder mt-5">Technologies</h2>
                    <p className="mt-4 p-3">I am skilled in some latest frontend technologies and I keep approach for problem solving skills</p>
                    <p>I'm familiar with👇</p>
                    <div className="Logos">
                       {
                        logos.map((items) =>
                            <img className="logo" src={items} alt='logo'></img>
                        )}                     
                    </div>
                </section>
                
                <section className="Dark mt-5">
                        <h2 className="m-auto fw-bolder mt-5">Blogs</h2>
                        <p className="mt-4 p-3">I am also working on some technical and non techincal blogs.</p>
                        <Link className="button p-2 mt-3" to='/projects'>Read Blogs</Link>
                </section>

                <section className="White">
                    <img className='Image mt-5' src={Mypic} alt="This is Immage"></img>
                    <h2 className="fw-bold m-auto mt-5">Let's Connect</h2>
                    <p className="mt-4">Want to get in touch? or Just want to say hello, feel free to contact me and I'll get back to you as soon as I can.</p>
                    <p>You can check out my social media links which are available below ...</p>
                </section>       
                                 
            </div>
            <footer>
            <h4 className="p-3">@Aishwary Patle | JS ❤️</h4>

                <div className="icons">
                        <a href="https://twitter.com/AishwaryPatle" rel="noreferrer"  target='_blank'>
                            <img className="icon" src={Twitter} alt='logo'></img>
                        </a>
                        <a href="https://www.linkedin.com/in/aishwary-patle-1b13401a1/" rel="noreferrer "  target='_blank'>
                            <img className="icon" src={Linkdin} alt='logo'></img>
                        </a>
                        <a href="mailto: aishwarypatle26@gmail.com" >
                            <img className="icon" src={Mail} alt='logo'></img>
                        </a>
                        <a href="https://www.instagram.com/aishwary_patle/" target='_blank' rel="noreferrer" >
                            <img className="icon" src={Insta} alt='logo'></img>
                        </a>
                        <a href="https://github.com/Aishwarypatle" target='_blank' rel="noreferrer " >
                            <img className="icon" src={Github} alt='logo'></img>
                        </a>
                </div>
            </footer>
            
            
           

            
        </>
    )
}


export default HomePage